import { OrderItemMiscState } from './order-item-misc-model';
import { OrderItemState } from './order-item-state';

export class OrderCompleteModel {

	public Id: number;
	public Uuid: string;
	public TestOrder: boolean;
	public AllOrderItemUuids: Array<string>;
	public AllOrderItemMiscUuids: Array<string>;
	public Notes: string;
	public NotesCustomerService: string;

	public OrderItems: Array<OrderItemState>;

	public OrderItemMiscs: Array<OrderItemMiscState>;
	public FullAddress: string;
	public ShipToName: string;
	public ConfirmationEmails: Array<string>;
	public Caution: string | null;

	public VisitDate: string;
	public VisitDateWithUserOffset: string | null;
	public EarliestDeliveryDate: string;
	public EarliestDeliveryDateWithUserOffset: string | null;
	public ShipToId: number | null;

	public FairName: string | null;
	public FairId: string | null;
	public AllowPartialShipment: boolean;
	public PaymentTerms: string | null;
	public NoVisit: boolean;
	public IsNewPartner: boolean;

	public signature: string;
	public ShopInfos: string;

}
